import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const GraphsModule = () => (
  <QPhototModuleSubtopic
    title="Graphs: Terminology, Representation & Traversal (BFS, DFS)"
    videos={[
      "https://www.youtube.com/embed/M4d4ni6L1Ps",
      "https://www.youtube.com/embed/5aqhqi0ZgdM",
      "https://www.youtube.com/embed/pcKY4hjDrxk",
      "https://www.youtube.com/embed/3tkcfvCNtM8",
      "https://www.youtube.com/embed/73sneFXuTEg"
    ]}
    takeaways={[]}
    questions={[
      { text: "Perform the BFS and DFS search algorithms on the following graph, following numeric order, starting at 1. Search for node 12 and find if the search is successful or not?",
        image:"/dsa_30.png"
       },
      { text: "Traverse the given graph with the necessary traversals by taking vertex 1 as start vertex. If several nodes can be chosen at some steps of the traversal pick the vertex that is alphabetically first. Use appropriate data structures and show all possible intermediate steps diagrammatically",
        image:"/dsa_31.png"
       },
      { text: "Write the routine to implement Breadth First Search and apply the algorithm to the figure given below",
        image:"/dsa_32.png"
       },
      { text: "What is the difference between the Breadth-First Search (BFS) and Depth-First Search (DFS) algorithms in graph traversal? Consider a directed graph with n nodes and m edges where each node is either black or white, how would you find the number of connected components that contain at least one black node? Which algorithm would you use and what steps would you take to solve this problem? Write the procedure for the same. Note: A connected component is a subgraph in which any two vertices are connected to each other by paths, and which is connected to no additional vertices in the subgraph." },
      { text: "Consider the following graph. Suppose that we want to traverse it, starting at node A.Come up with pseudocode to implement breadth-first search on a given graph, given a starting node and find an adjacency matrix representation of the graph. What data structure do you use?",
        image:"/dsa_33.png"
       },
      { text: "Perform topological sorting on the above directed graph. Now, for performing Depth First Traversal, assume that all the edges in the graph are undirected. Generate, step by step, the resultant output of Depth First Traversal, along with the finishing time for all the vertices, starting from the vertex A. NOTE: The adjacency matrix/list has the following order A, D, E, F, C, B.",
        image:"/dsa_34.png"
       }
    ]}
    exampleVideos={[]}
  />
);

export default GraphsModule;
